import './NoPrint.scss'
export const NoPrint = ({ children }) => {
  return <div className="no-print">{children}</div>
}
